import { usePowerMonitorSystemHealth as useCommonPowerMonitorSystemHealth, SystemHealthStatus } from 'common';

import { useAppSync } from '../../contexts/AppSyncContext';
import { Status } from '../../types/Status';

// Web-hub adapter to maintain backward compatibility
export function usePowerMonitorSystemHealth() {
  const { selectedHubId } = useAppSync();
  const commonResult = useCommonPowerMonitorSystemHealth(selectedHubId);

  // Map SystemHealthStatus to web-hub Status enum
  const mapStatus = (status: SystemHealthStatus): Status => {
    switch (status) {
      case SystemHealthStatus.Good:
        return Status.Good;
      case SystemHealthStatus.Poor:
        return Status.Poor;
      case SystemHealthStatus.Error:
        return Status.Error;
      default:
        return Status.Good;
    }
  };

  return {
    status: mapStatus(commonResult.status),
    loading: commonResult.loading,
    timestamp: commonResult.timestamp,
  };
}
